import { Configuration, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import { config } from '../config';

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig: Configuration = {
    auth: {
        // 'Application (client) ID' of app registration in Azure portal - this value is a GUID
        clientId: config.BEEHIVE_AZUREAD_CLIENT_ID,
        // Full directory URL, in the form of https://login.microsoftonline.com/<tenant-id>
        authority: `https://login.microsoftonline.com/${config.BEEHIVE_AZUREAD_TENANT_ID}`,
        // Full redirect URL, in form of http://localhost:3000/
        redirectUri: `${location.protocol}//${location.host}/`,
    },
    cache: {
        cacheLocation: 'localStorage', // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level: LogLevel, message: string) => {
                // Logger silenced for production
            },
        },
    },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ['openid', 'profile']
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphRequest = {
    scopes: ['User.Read']
};

export const msalInstance = new PublicClientApplication(msalConfig);

// Account selection helper
export const getActiveAccount = () => {
    return msalInstance.getActiveAccount();
};

export const setActiveAccount = (account: any) => {
    msalInstance.setActiveAccount(account);
};
